<template>
    <div></div>
</template>

<script>
import moment from 'moment'
import SavRequestModal from '@/components/SavRequestModal'
import eventHub from '@/eventHub'

export default {
    components: {SavRequestModal},

    watch: {
        open: function(value) {
            if (value === true) {
                if (!localStorage['form-data']) {
                    this.$nextTick(() => {
                        this.open = false
                    })
                }
            }
        },
        selected: {
            deep: true,
            handler: function(value) {
                this.emitChange()
            }
        }
    },

    data() {
        return {
            loading: false,
            data: null,
            selected: null,
            open: true,
            canOpen: {
                authorize: true,
                message: null,
            },
            nextBlock: null,
            requestModalParams: {
                label: null,
                libelle: null
            }
        }
    },

    filters: {
        momentDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },

        momentWithHour(date) {
            return moment(date).format('DD/MM/YYYY à hh:mm');
        }
    },

    methods: {
        emitChange() {
            this.open = false
            if (this.$formTool.blockData(this.nextBlock)) {
                this.$emit('next', {current: this.$formTool.blockData(this.$options.name), next: this.$formTool.blockData(this.nextBlock)})
            }
        },

        displayRequestModal() {
            if (this.requestModalParams.label && this.requestModalParams.libelle) {
                this.$modal.show('request-' + this.requestModalParams.libelle)
            }
        },

        hideRequestModal() {
            if (this.requestModalParams.libelle) {
                this.$modal.hide('request-' + this.requestModalParams.libelle)
            }
        },

        removeOpenAfterSetCase() {
            const closeForm = () => {
                this.canOpen.authorize = false
                this.canOpen.message = this.$t('form.alert.vous_ne_pouvez_pas_modifier_ces_informations_lorsque_le_dossier_est_cree')
            }
            if (this.$formTool.getFormData('set-case')) {
                closeForm()
            }

            eventHub.$on('set-setcase', (cardInfo) => {
                closeForm()
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/extends/FormCardExtension.vue